/** If possible, use `isPcbDesignItem` instead. */
export function isPcbSpecification({ designators }: { designators: string[] }): boolean {
    return designators.includes('PCB');
}
